<template>
  <Modal :show-modal="showInviteUserModal" @close="toggleInviteUserModal">
    <template #header>
      <div class="inviteUser__header">
        <h2 class="inviteUser__title">
          {{ $t('customer.users_permissions.modal.title') }}
        </h2>
        <span class="inviteUser__text">{{
          $t('customer.users_permissions.modal.text')
        }}</span>
      </div>
    </template>
    <template #body>
      <div class="inviteUser__body">
        <input
          v-model="email"
          :placeholder="$t('shared.label.email')"
          class="inviteUser__input"
          type="email"
        />
        <p v-if="userIsInvited" class="field__warning">
          {{ $t('shared.label.user_is_invited') }}
        </p>
      </div>
    </template>
    <template #footer>
      <div class="wrapper">
        <BtnPrimary
          :disabled="disableButton"
          :title="$t('customer.users_permissions.modal.btn.send')"
          @click="onSend(email)"
        />
        <BtnSecondary
          :title="$t('shared.button.close')"
          @click="toggleInviteUserModal"
        />
      </div>
    </template>
  </Modal>
</template>
<script setup>
import Modal from '@/components/shared/Modal'
import BtnPrimary from '@/components/shared/btn/BtnPrimary'
import BtnSecondary from '@/components/shared/btn/BtnSecondary'
import { validateEmail } from '@/helpers/validation'
import i18n from '@/i18n'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const $t = i18n.t

const email = ref('')

const showInviteUserModal = computed(
  () => store.state.modals.showInviteUserModal
)
const usersInvited = computed(() => store.state.invitations.usersInvited)

const userIsInvited = computed(() => {
  if (!usersInvited.value) {
    return []
  }
  const isInvited = usersInvited.value.find(
    (u) => u.attributes.email === email.value
  )
  return isInvited
})
const disableButton = computed(() => {
  if (userIsInvited.value !== undefined) return true
  if (validateEmail(email.value)) return false
  return true
})

const sendInvitation = (payload) =>
  store.dispatch('invitations/sendInvitation', payload)
const toggleInviteUserModal = () => store.commit('modals/toggleInviteUserModal')

function onSend(userEmail) {
  sendInvitation({ email: userEmail })
  email.value = ''
  toggleInviteUserModal()
}
</script>

<style lang="scss" scoped>
.wrapper {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  :deep() {
    .btn__primary {
      margin: auto;
      margin-bottom: 1rem;
    }
    .btn__secondary {
      margin: auto;
    }
  }
}

.inviteUser,
.removeUser {
  &__header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #454a5b;
    padding-top: 0px;

    .inviteUser,
    .removeUser {
      &__title {
        font-weight: 600;
        font-size: 20px;
      }
      &__text {
        display: block;
        font-size: 14px;
      }
    }
    .removeUser__text {
      text-align: center;
    }
  }
  &__body {
    .inviteUser__input {
      border: 1px solid #e6e7ec;
      border-radius: var(--border-radius);
      width: 100%;
      max-width: 500px;
      margin: 0 auto;
      display: block;
      padding: 10px;
      color: #6e7075;
      outline: none;
      &:hover {
        border: 1px solid #2c3fd5 !important;
        .icon {
          color: #2c3fd5 !important;
        }
      }

      &:focus-within {
        border: 1px solid #0d1fb8 !important;
      }
    }
    .field__warning {
      font-size: 14px;
      color: red;
      margin-top: 5px;
    }
  }
}
</style>
